<a class="listshare">
  <i class="fa {{product.wishlist?'fa-bookmark':'fa-bookmark-o'}}"
     (click)="addToWishlist($event.target)" *ngIf="accessToken"></i>

  <i class="fa {{product.wishlist?'fa-bookmark':'fa-bookmark-o'}}"
     href="#modal-center" uk-toggle *ngIf="!accessToken"></i>
</a>
